import { AssetsService } from "app/services/AssetsService";

import { AI_LOADING_GIF } from "./constants";
import * as SC from "./styles";

type AILoader = {
    title: string;
    subTitle?: string;
    classname?: string;
};

export const AILoader = ({ title, subTitle, classname }: AILoader) => {
    return (
        <SC.LoaderWrapper className={classname}>
            <SC.LoaderGif
                src={AssetsService.assetUrl(AI_LOADING_GIF)}
                alt={title}
            />
            <SC.TextWWrapper>
                <SC.Title>{title}</SC.Title>

                {subTitle ? <SC.SubTitle>{subTitle}</SC.SubTitle> : null}
            </SC.TextWWrapper>
        </SC.LoaderWrapper>
    );
};
